/**Import react section */
import React, { Fragment } from 'react'
import withImmutablePropsToJS from 'with-immutable-props-to-js'
import propTypes from 'prop-types'

import { Typography, ButtonGroup, Tooltip, Button } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import AddSapIcon from '@material-ui/icons/LoupeOutlined'
import ImportFile from '@material-ui/icons/CloudUpload'

/**Import components section */
import SideBar from '../../common/DashboadSideBar'
import FilterSelect from '../../common/Filters/FilterSelect'
import ReportDateRange from '../../common/ReportDateRange/ReportDateRange'
import { Layout, Content, Header, HeaderBreadCrum } from '../../layouts/AuthenticatedLayout'
import SearchBox from '../../common/SearchToolbox'
import Authorization from '../../common/AuthorizationEvaluation'
import Datagrid from '../../common/apsys.datagrid.materialui/DataGrid'
import Pagination from '../../common/Pagination/Pagination'
import ImagesNoInformation from '../../common/ImagesNoInformation'
import DashboardCard from '../../dashboard/components/DashboardCard'

import defaultTheme from '../../../resources/themes/default'
import { getDatagridConfiguration } from '../resources/requestIndexConfig'
import { useDataGridToolbarStyle } from '../../../resources/styles/CommonIndexStyles'
import { useCreateDesktopStyle } from '../resources/useStyles'
import {
	IMBERA_TECHNICIAN,
	PORTAL_ADMINISTRATOR,
	SPARE_PARTS_IMBERA_USA,
	SPARE_PARTS_IMBERA_MX,
	SERVICE_PROVIDER_MANAGER,
	SERVICE_PROVIDER_TECHNICIAN,
	CUSTOMER_MANAGER,
	CUSTOMER_TECHNICIAN,
	VISUALIZER
} from '../../../resources/RolesEnum'
import { GetStatusSpareParts, GetStatusTrackingNumber, GetWarehouseType } from '../../../store/helpers/FilterHelper'
import { getUsersOptionsByRole } from '../../../store/helpers/UserHelper'

import { getOptions } from '../../../store/helpers/FilterHelper'

/**
 * View create desktop
 */
const IndexDesktopView = (props) => {
	const classes = useCreateDesktopStyle()
	const {
		userProfile,
		sparePartsIndex,
		onOpenRequest,
		pagination,
		onChangePage,
		onChangeSortingCriteria,
		internalUsers,
		onDownloadReportGral,
		onDownloadReportGralFast,
		isDownloadReport,
		allCustomers,
		serviceProviders,
		openImportReferenceSAP
	} = props
	let configuration = getDatagridConfiguration()
	let technicianUserOptions = getUsersOptionsByRole(IMBERA_TECHNICIAN, internalUsers, true)
	let serviceProvider = getOptions(serviceProviders)
	let customers = getOptions(allCustomers)

	const onRenderContent = () => {
		if (sparePartsIndex.requests.length >= 1 || sparePartsIndex.isLoading) {
			return (
				<Datagrid
					headers={configuration}
					isLoading={sparePartsIndex.isLoading}
					data={sparePartsIndex.requests}
					onChangeSortingCriteria={onChangeSortingCriteria}
					sortBy={pagination.orderBy}
					sortDirection={pagination.orderType}
					onItemClick={onRowClick}
				/>
			)
		} else {
			return (
				<ImagesNoInformation
					query={props.searchValue}
					data={sparePartsIndex.requests}
					isLoading={sparePartsIndex.isLoading}
					titleData={'No exist spart part request'}
				/>
			)
		}
	}

	const onRowClick = (sender, item) => {
		if (onOpenRequest) {
			onOpenRequest(item)
		}
	}

	return (
		<Layout>
			<Header
				key={'AuthenticatedHeader'}
				breadcrumbs={
					<HeaderBreadCrum>
						<Typography color='secondary'>Spare Part Request</Typography>
					</HeaderBreadCrum>
				}
			/>
			<SideBar key={'AuthenticatedSideBar'} onChangeLocation={props.onChangeLocation} selectedButtonIndex={3} userProfile={userProfile} />
			<Content key={'AuthenticatedContent'}>
				<div className={classes.rootIndex}>
					<div className={classes.cardList}>
						<DashboardCardLists isLoadingDashboard={props.isLoadingDashboard} dashboard={props.dashboard} />
					</div>
					<div className={classes.container}>
						<DataGridToolbar
							onCreateRequest={props.onCreateRequest}
							userProfile={userProfile}
							allowedRoles={[
								IMBERA_TECHNICIAN,
								SERVICE_PROVIDER_MANAGER,
								SERVICE_PROVIDER_TECHNICIAN,
								CUSTOMER_MANAGER,
								CUSTOMER_TECHNICIAN
							]}
							allowedRolesManual={[
								IMBERA_TECHNICIAN,
								CUSTOMER_MANAGER,
								CUSTOMER_TECHNICIAN,
								SERVICE_PROVIDER_MANAGER,
								SERVICE_PROVIDER_TECHNICIAN
							]}
							onChange={props.onChangeSearchValue}
							searchValue={props.searchValue}
							technicianUserOptions={technicianUserOptions}
							onDownloadReportGral={onDownloadReportGral}
							onDownloadReportGralFast={onDownloadReportGralFast}
							isDownloadReport={isDownloadReport}
							onCreateRequestManual={props.onCreateRequestManual}
							serviceProviders={serviceProvider}
							customers={customers}
							openImportReferenceSAP={openImportReferenceSAP}
						/>
						{onRenderContent()}
					</div>
					<div className={classes.pagination}>
						<div className={classes.flexGrow} />
						<Pagination
							count={pagination.total ? pagination.total : 0}
							page={pagination.pageNumber ? pagination.pageNumber : 0}
							onChangePage={onChangePage}
						/>
					</div>
				</div>
			</Content>
		</Layout>
	)
}
IndexDesktopView.propTypes = {
	onCreateRequest: propTypes.func.isRequired,
	sparePartsIndex: propTypes.shape({
		isLoading: propTypes.bool.isRequired
	}),
	/**
	 * Open a spare part request
	 */
	onOpenRequest: propTypes.func.isRequired,
	/**
	 * Initial search value
	 */
	searchValue: propTypes.string,
	/**
	 * On change search value
	 */
	onChangeSearchValue: propTypes.func.isRequired,
	/**
	 * The object contains the paginated
	 */
	pagination: propTypes.shape({
		/**
		 * Determine the initial sort by column
		 */
		orderBy: propTypes.string,
		/**
		 * Defines the initial sort direction
		 */
		orderType: propTypes.oneOf(['asc', 'desc']),
		/**
		 * Defines the total de retails pagination
		 */
		total: propTypes.number,
		/**
		 * Defines the page number pagination
		 */
		pageNumber: propTypes.number
	}),
	/**
	 * On change sort criteria callback
	 */
	onChangeSortingCriteria: propTypes.func.isRequired
}
IndexDesktopView.defaultProps = {
	sparePartsIndex: {
		isLoading: false
	},
	onOpenRequest: () => console.warn('Callback [onOpenRequest] no defined'),
	onChangeSearchValue: () => console.warn('Callback [onChangeSearchValue] no defined')
}
export default withImmutablePropsToJS(IndexDesktopView)

/**
 * Datagrid column toolbar
 */
const DataGridToolbar = (props) => {
	const classes = useDataGridToolbarStyle()
	return (
		<div className={classes.searchIndex}>
			<SearchBox placeholder='Search request' onChange={props.onChange} value={props.searchValue} />
			<ButtonGroup component='span' variant='text' size='small' className={classes.buttonsGroupContainer}>
				<ReportDateRange onDownloadReport={props.onDownloadReportGral} isDownloadReport={props.isDownloadReport} />
					<ReportDateRange
						onDownloadReport={props.onDownloadReportGralFast}
						isDownloadReport={props.isDownloadReport}
						title='Fast Download'
					/>
				<Authorization profile={props.userProfile} allowedRoles={props.allowedRoles}>
					<Tooltip component='span' title='Create spare parts request'>
						<Button onClick={props.onCreateRequest} className={classes.buttonsGroup}>
							<AddIcon />
						</Button>
					</Tooltip>
				</Authorization>
				<Authorization profile={props.userProfile} allowedRoles={props.allowedRolesManual}>
					<Tooltip component='span' title='Create spare parts request manual'>
						<Button onClick={props.onCreateRequestManual} className={classes.buttonsGroupManual}>
							<AddSapIcon />
						</Button>
					</Tooltip>
				</Authorization>
				<Authorization profile={props.userProfile} allowedRoles={[PORTAL_ADMINISTRATOR]}>
					<Tooltip component='span' title='Import References'>
						<Button onClick={props.openImportReferenceSAP} className={classes.buttonsGroupBlue}>
							<ImportFile />
						</Button>
					</Tooltip>
				</Authorization>
			</ButtonGroup>
			<div className={classes.flexGrow} />
			<FilterSelect
				nameFilter={'Tracking Status'}
				data={GetStatusTrackingNumber()}
				nameFilterUrl={'trackingFilter'}
				isVisibleSearch={false}
				isActiveCleanButton={true}
				userProfile={props.userProfile}
				roles={[
					IMBERA_TECHNICIAN,
					PORTAL_ADMINISTRATOR,
					SPARE_PARTS_IMBERA_USA,
					SPARE_PARTS_IMBERA_MX,
					SERVICE_PROVIDER_MANAGER,
					SERVICE_PROVIDER_TECHNICIAN,
					CUSTOMER_MANAGER,
					VISUALIZER
				]}
			/>
			<FilterSelect
				nameFilter={'Warehouses'}
				data={GetWarehouseType()}
				nameFilterUrl={'warehouseFilter'}
				isVisibleSearch={true}
				userProfile={props.userProfile}
				roles={[
					IMBERA_TECHNICIAN,
					PORTAL_ADMINISTRATOR,
					SPARE_PARTS_IMBERA_USA,
					SPARE_PARTS_IMBERA_MX,
					SERVICE_PROVIDER_MANAGER,
					SERVICE_PROVIDER_TECHNICIAN,
					CUSTOMER_MANAGER,
					VISUALIZER
				]}
			/>
			<FilterSelect
				nameFilter={'Technicians'}
				data={props.technicianUserOptions}
				nameFilterUrl={'technicianFilter'}
				isVisibleSearch={true}
				userProfile={props.userProfile}
				roles={[IMBERA_TECHNICIAN, PORTAL_ADMINISTRATOR, SPARE_PARTS_IMBERA_USA, SPARE_PARTS_IMBERA_MX, VISUALIZER]}
			/>
			<FilterSelect
				nameFilter={'PROVIDERS'}
				data={props.serviceProviders}
				nameFilterUrl={'providers'}
				isVisibleSearch={true}
				userProfile={props.userProfile}
				roles={[IMBERA_TECHNICIAN, PORTAL_ADMINISTRATOR, SPARE_PARTS_IMBERA_USA, SPARE_PARTS_IMBERA_MX, VISUALIZER]}
			/>
			<FilterSelect
				nameFilter={'CUSTOMERS'}
				data={props.customers}
				nameFilterUrl={'customers'}
				isVisibleSearch={true}
				userProfile={props.userProfile}
				roles={[IMBERA_TECHNICIAN, PORTAL_ADMINISTRATOR, SPARE_PARTS_IMBERA_USA, SPARE_PARTS_IMBERA_MX, VISUALIZER]}
			/>
			<FilterSelect
				nameFilter={'STATUS'}
				data={GetStatusSpareParts()}
				nameFilterUrl={'statusFilter'}
				isVisibleSearch={false}
				userProfile={props.userProfile}
				roles={[
					IMBERA_TECHNICIAN,
					PORTAL_ADMINISTRATOR,
					SPARE_PARTS_IMBERA_USA,
					SPARE_PARTS_IMBERA_MX,
					SERVICE_PROVIDER_MANAGER,
					SERVICE_PROVIDER_TECHNICIAN,
					CUSTOMER_MANAGER,
					VISUALIZER
				]}
			/>
		</div>
	)
}

DataGridToolbar.propTypes = {
	/**
	 * On change search value
	 */
	onChange: propTypes.func.isRequired,
	/**
	 * Initial search value
	 */
	searchValue: propTypes.string,
	/**
	 * Change the list mode to card and vice versa
	 * */
	switchViewMode: propTypes.func.isRequired,
	/**
	 * Determines whether card mode is stored in local storage
	 */
	gridMode: propTypes.bool,
	/**
	 * Open side panel to add new  user's
	 */
	onCreateRequest: propTypes.func.isRequired,
	/**
	 * Download report general for spare part requests
	 */
	onDownloadReportGral: propTypes.func.isRequired,
	/**
	 * Determinate if is download report general for spare part requests
	 */
	isDownloadReport: propTypes.bool
}

DataGridToolbar.defaultProps = {
	gridMode: false,
	searchValue: '',
	isDownloadReport: false,
	onChange: () => console.warn('Callback [onChange] no defined'),
	switchViewMode: () => console.warn('Callback [switchViewMode] no defined'),
	onCreateRequest: () => console.warn('Callback [onCreateRequest] no defined'),
	onDownloadReportGral: () => console.warn('Callback [onDownloadReportGral] no defined')
}

/**
 * DashboardCardLists component
 */
const DashboardCardLists = (props) => {
	const { dashboard } = props

	return (
		<Fragment>
			<DashboardCard
				mainColor={defaultTheme.palette.serviceStatus.newServiceMain}
				secondaryColor={defaultTheme.palette.serviceStatus.newServiceDark}
				totalServices={dashboard ? dashboard.totalDraft : 0}
				percentajeValue={dashboard ? dashboard.percentageTotalDraft : 0}
				label={'Draft Parts'}
			/>
			<DashboardCard
				mainColor={defaultTheme.palette.serviceStatus.waitingSparePartsMain}
				secondaryColor={defaultTheme.palette.serviceStatus.waitingSparePartsDark}
				totalServices={dashboard ? dashboard.totalInProcess : 0}
				percentajeValue={dashboard ? dashboard.percentageTotalInProcess : 0}
				label={'Submitted Parts'}
			/>
			<DashboardCard
				mainColor={defaultTheme.palette.serviceStatus.assignedMain}
				secondaryColor={defaultTheme.palette.serviceStatus.assignedDark}
				totalServices={dashboard ? dashboard.totalSendToMx : 0}
				percentajeValue={dashboard ? dashboard.percentageTotalSendToMx : 0}
				label={'Send Imbera MX Parts'}
			/>
			<DashboardCard
				mainColor={defaultTheme.palette.serviceStatus.completedServiceMain}
				secondaryColor={defaultTheme.palette.serviceStatus.completedServiceDark}
				totalServices={dashboard ? dashboard.total : 0}
				percentajeValue={dashboard ? dashboard.totalPercentage : 0}
				label={'Total Open'}
			/>
		</Fragment>
	)
}
